import {
  getItem,
  KEY_ACTIVE_ROL,
  KEY_ACTIVE_ROL_NAME,
  KEY_AMBASSADOR_ID,
  KEY_CHECKBOX_EXCLUDE,
  KEY_COMPANY_ID,
  KEY_COMPANY_LOGO,
  KEY_COMPANY_NAME,
  KEY_DASHBOARD_BIRTHDAY_CHECK,
  KEY_EMPLOYEE_ID,
  KEY_ISOLATED_METRICS,
  KEY_MODULES,
  KEY_ONBOARDING,
  KEY_ORGANIZATION_COLLABORATORS_COLUMNS_FILTER,
  KEY_ORGANIZATION_COLLABORATORS_DIVISION_FILTER,
  KEY_ORGANIZATION_COLLABORATORS_LEADERS_FILTER,
  KEY_ORGANIZATION_COLLABORATORS_SEGMENT_FILTER,
  KEY_ORGANIZATION_COLLABORATORS_TEXT_FILTER,
  KEY_ORGANIZATION_DIVISIONS_DIVISION_FILTER,
  KEY_ORGANIZATION_DIVISIONS_FILTER,
  KEY_ORGANIZATION_DIVISIONS_LEVEL_FILTER,
  KEY_ORGANIZATION_DIVISIONS_PARENT_FILTER,
  KEY_ORGANIZATION_DIVISIONS_TEXT_FILTER,
  KEY_TEMP_AF,
  KEY_TOKEN,
  KEY_TRANSFER_USER,
  KEY_TRIAL_ACTIVE,
  KEY_TRIAL_DURATION,
  KEY_TRIAL_END_DATE,
  KEY_TRIAL_MAX_COLLABORATORS,
  KEY_TRIAL_START_DATE,
  KEY_TWO_FACTOR_AUTH_PENDING,
  KEY_USER_EMAIL,
  KEY_USER_ID,
  KEY_USER_NAME,
  KEY_USER_PASSWORD,
  KEY_USER_PHOTO,
  KEY_USER_ROLES,
  KEY_USER_ROLES_TEXT,
  LOCAL_TOKEN,
  setItem,
  KEY_ORGANIZATION_DEMO,
  LOCAL_LOGIN_LANGUAGE,
  SHOWED_FEEDBACK_SURVEY,
  KEY_FEATURE_FLAGS,
  KEY_COMPANY_HUBSPOT,
  KEY_COMPANY_COUNTRY,
  KEY_COMPANY_SUPPORT_CHANNEL,
  KEY_PDA_IA_ENABLED,
  KEY_NEW_PDA_IA_NOTIFICATION,
  KEY_VISMA_PEOPLE_SYNC_ENABLED,
  KEY_AI_LIMIT_REACHED,
} from "../../utils/storage"
import {
  LOGIN_COMPANY_WATCHER,
  LOGIN_PROOF_INTEGRATED,
  LOGIN_WATCHER,
  TWO_FACTOR_AUTH_RESEND_WATCHER,
} from "./constants"
import { call, put, takeLatest } from "redux-saga/effects"
import { history, push } from "connected-react-router"
import { loginExceed, loginFailed, loginSuccess } from "./actions"

import { ROLES_ADMIN_MANDU } from "../../utils/constants"
import axios from "axios"
import { has } from "lodash"
import { message } from "antd"
import { validate } from "../../utils/functions"
import { sanitize, setLanguage } from "../../utils/i18n"
import {
  buttonAction_s,
  testSnowplow,
} from "../../components/Snowplow/config2"
import { verifyFeatureFlag } from "../../utils/feature-flags"

function messageProgress(messagex) {
  message.loading(messagex, 10000000000)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

function loginCompanyApi(token) {
  return axios.request({
    method: "post",
    url: `${process.env.API_URL}companies/login-again-after-change`,
    data: { token: token.token },
    validateStatus: (status) => true, // I'm always returning true,
  })
}

function loginApi(authParams) {
  return axios.request({
    method: "post",
    url: `${process.env.API_URL}oauth/login`,
    data: {...authParams, loginLanguage: LOCAL_LOGIN_LANGUAGE()},
    validateStatus: (status) => true, // I'm always returning true,
  })
}

function loginProofIntegratedApi(authParams) {
  return axios.request({
    method: "post",
    url: `${process.env.API_URL}oauth/hash-login`,
    data: authParams,
    validateStatus: (status) => true, // I'm always returning true,
  })
}

function setLocalStorageDataLogin(data) {
  let userRolesText = []
  data.roles?.map((row) => userRolesText.push(row.text))
  const company = data.companies
  setItem(SHOWED_FEEDBACK_SURVEY,data.showed_feedback_survey)
  setItem(KEY_USER_ID, data.id)
  setItem(KEY_ORGANIZATION_DEMO, company.demo)
  setItem(KEY_TRANSFER_USER, data.transfer_user)
  setItem(KEY_USER_PHOTO, data.picture_profile)
  setItem(KEY_USER_NAME, data.name)
  setItem(KEY_USER_EMAIL, data.email)
  setItem(KEY_AMBASSADOR_ID, data.id_ambassador)
  setItem(KEY_EMPLOYEE_ID, data.id_employee)
  setItem(KEY_ACTIVE_ROL, data.active_role)
  setItem(KEY_ACTIVE_ROL_NAME, data.active_role_name)
  setItem(KEY_USER_ROLES, JSON.stringify(data.roles))
  setItem(KEY_USER_ROLES_TEXT, JSON.stringify(userRolesText))
  setItem(KEY_TOKEN, data.access_token)
  setItem(KEY_MODULES, JSON.stringify(data.modules))
  setItem(KEY_TWO_FACTOR_AUTH_PENDING, data.two_factor_auth_active)
  if(validate.exist(data.is_new_pda_ia_notification)){
    setItem(KEY_NEW_PDA_IA_NOTIFICATION, data.is_new_pda_ia_notification)
  }
  if (validate.exist(company.id_company)) {

    setItem(KEY_COMPANY_ID, company.id_company)
    setItem(KEY_COMPANY_HUBSPOT, company.hubspot_company_id)
    setItem(KEY_COMPANY_COUNTRY, company.country || null)
    setItem(KEY_COMPANY_SUPPORT_CHANNEL, company.support_channel || null)
    setItem(
      KEY_COMPANY_LOGO,
      validate.exist(company.logo) ? company.logo : null
    )
    setItem(KEY_COMPANY_NAME, company.name)
    setItem(KEY_TRIAL_ACTIVE, company.trial_active)
    setItem(KEY_TRIAL_DURATION, company.trial_duration)
    setItem(KEY_TRIAL_END_DATE, company.trial_end_date)
    setItem(KEY_TRIAL_MAX_COLLABORATORS, company.trial_max_collaborators)
    setItem(KEY_TRIAL_START_DATE, company.trial_start_date)
  } else {
    setItem(KEY_COMPANY_ID)
    setItem(KEY_COMPANY_LOGO)
    setItem(KEY_COMPANY_NAME)
    setItem(KEY_COMPANY_SUPPORT_CHANNEL)
    setItem(KEY_TRIAL_ACTIVE)
    setItem(KEY_TRIAL_DURATION)
    setItem(KEY_TRIAL_END_DATE)
    setItem(KEY_TRIAL_MAX_COLLABORATORS)
    setItem(KEY_TRIAL_START_DATE)
    setItem(KEY_COMPANY_HUBSPOT)
    setItem(KEY_COMPANY_COUNTRY)
  }
  setItem(KEY_COMPANY_NAME, company.name)
  setItem(KEY_ORGANIZATION_DIVISIONS_FILTER, JSON.stringify(["ambassadors"]))
  setItem(KEY_ORGANIZATION_DIVISIONS_DIVISION_FILTER, JSON.stringify([]))
  setItem(KEY_ORGANIZATION_DIVISIONS_PARENT_FILTER, JSON.stringify([]))
  setItem(KEY_ORGANIZATION_DIVISIONS_LEVEL_FILTER, JSON.stringify([]))
  setItem(KEY_ORGANIZATION_DIVISIONS_TEXT_FILTER, "")
  setItem(KEY_DASHBOARD_BIRTHDAY_CHECK, JSON.stringify([]))
  setItem(KEY_ORGANIZATION_COLLABORATORS_TEXT_FILTER, "")
  setItem(
    KEY_ORGANIZATION_COLLABORATORS_COLUMNS_FILTER,
    JSON.stringify(["email", "division", "segment", "leader", "team"])
  )
  setItem(KEY_ORGANIZATION_COLLABORATORS_DIVISION_FILTER, JSON.stringify([]))
  setItem(KEY_ORGANIZATION_COLLABORATORS_SEGMENT_FILTER, JSON.stringify([]))
  setItem(KEY_ORGANIZATION_COLLABORATORS_LEADERS_FILTER, JSON.stringify([]))
  setItem(KEY_CHECKBOX_EXCLUDE, false)
  setItem(KEY_ISOLATED_METRICS, false)

  if(validate.exist(data.companies.feature_flags)){
    setItem(KEY_FEATURE_FLAGS, JSON.stringify(data.companies.feature_flags))
  }

  if(validate.exist(data.companies.pdas_ia_enable)){
    setItem(KEY_PDA_IA_ENABLED, data.companies.pdas_ia_enable)
  }
  if(validate.exist(data.companies.visma_people_sync_enabled)){
    setItem(KEY_VISMA_PEOPLE_SYNC_ENABLED, data.companies.visma_people_sync_enabled)
  }

  if(validate.exist(data.is_new_pda_ia_notification)){
    setItem(KEY_NEW_PDA_IA_NOTIFICATION, data.is_new_pda_ia_notification)
  }
}

export function* loginSaga(action) {
  try {
    const result = yield call(loginApi, action.payload)
    const { data } = result.data

    switch (result.status) {
      case 202:
        if (data.language) {
          setLanguage(data.language)
        }
        // console.log(data)
        yield setLocalStorageDataLogin(data)
        yield generateOnboarding(data.onboarding)
        // window.initializeChatWidget();
        /*
        if (typeof window.Intercom !== 'undefined') {
          Intercom("show") ;
           // window.fcWidget.open();
        }
        */
        // google analytics code
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: "login",
          userId: data.id,
        })

        if (data.two_factor_auth_active && LOCAL_TOKEN() != "") {
          sessionStorage.setItem(KEY_TEMP_AF, JSON.stringify(action.payload))
        }

        // validate when is demo
        if (data.companies.demo == 0) {
          // snowplow
          const data_button = {
            category: "Login",
            action: "Iniciar sesion",
            label: "Click iniciar sesion",
            property: "button",
            value: data.id,
          }
          /*  initSnowplow(
            data.id,
            data.companies.id_company,
            data.roles.text,
            data.companies.name
          )
          buttonAction(data_button) */
          // window.initializeChatWidget();
          /*
          if (typeof window.Intercom !== 'undefined') {
              Intercom("show") ;
              //window.fcWidget.open();
          }
          */
          setTimeout(testSnowplow(),0)
          buttonAction_s(data_button)

        }

        //verifyFeatureFlag('test-no-existe')

        
        if (
          data.modules.length === 0 &&
          ROLES_ADMIN_MANDU.includes(data.active_role)
        ) {
          yield put(push("/companies"))
        } else {


          yield put(loginSuccess(data))
        }

        break
      case 422:
        var { error } = data
        if (has(error, "user")) {
          yield call(messageFailed, error.user[0])
        }

        if (has(error, "email") && !has(error, "password")) {
          yield call(messageFailed, error.email[0])
        }

        if (!has(error, "email") && has(error, "password")) {
          yield call(messageFailed, error.password[0])
        }

        if (has(error, "email") && has(error, "password")) {
          yield call(messageFailed, error.email[0])
          yield call(messageFailed, error.password[0])
        }
        if (has(error, "recaptchaToken")) {
          yield call(messageFailed, sanitize(error.recaptchaToken[0]))
        }

        if (has(error, "two_factor_auth_message")) {
          yield call(messageFailed, error.two_factor_auth_message)
        }

        yield put(loginFailed())
        break
      case 429:
        var { error } = data
        if (has(error, "email")) {
          yield call(messageFailed, error.email[0])
        }
        yield put(loginFailed())
        break
      default:
        yield call(messageFailed, "Error en el servidor")
        yield put(loginFailed())
        break
    }
  } catch (e) {
    yield call(messageFailed, "Error en el servidor")
    yield put(loginFailed())
  }
}

export function* loginCompanySaga(action) {
  try {
    const result = yield call(loginCompanyApi, action.payload)
    const { data } = result.data
    returnMessage(result)
    yield setLocalStorageDataLogin(data.result)
    generateOnboarding(false)
    const data_button = {
      category: "Login",
      action: "Iniciar sesion",
      label: "Click iniciar sesion",
      property: "button",
      value: data.id,
    }
    // window.initializeChatWidget();
    /*
    if (typeof window.Intercom !== 'undefined') {
        Intercom("show") ;
      //  window.fcWidget.open();
    }
      */
    setTimeout(testSnowplow(),0)
    buttonAction_s(data_button)
    //verifyFeatureFlag('new-reports')
    yield put(loginSuccess(data.result))

    yield put(push("/organization"))
  } catch (e) {
    yield call(messageFailed, "Error en el servidor")
    yield put(loginFailed())
  }
}

function generateOnboarding(onboarding) {
  if (onboarding === undefined) {
    onboarding = []
  }
  setItem(
    KEY_ONBOARDING,
    Array.isArray(onboarding) ? JSON.stringify(onboarding) : onboarding
  )
}

export function* loginProofIntegratedSaga(action) {
  try {
    const isHash =
      typeof action.payload.hash !== "undefined" && action.payload.hash !== null
    const result = yield call(loginProofIntegratedApi, action.payload)
    const { data } = result.data
    switch (result.status) {
      case 202:
        yield setLocalStorageDataLogin(data)
        generateOnboarding(data.onboarding)

        //if(!sessionStorage.has('hideheader')) {
          // window.initializeChatWidget();
          /*
          if (typeof window.Intercom !== 'undefined') {
              Intercom("show") ;
              window.fcWidget.open();
          }
            */
        // }

        if (window.Appcues) {
          window.Appcues.track("logged id")
        }
       
        if (isHash) {

          if (data.transfer_user) {
            message.success("Se ha ingresado a la plataforma de Engagement.")
          } else {
            yield call(
              messageFailed,
              "Tu acceso a la plataforma de Desempeño ha sido removido. Comunícate con el administrador del sistema para más información."
            )
          }
        }
        
        if(action.payload?.hideheader) {
          sessionStorage.setItem('hideheader', true);
          sessionStorage.setItem('hash', action.payload.hash);
        }

        if(action.payload?.aiLimitReached !== undefined) {
          setItem(KEY_AI_LIMIT_REACHED, action.payload.aiLimitReached)
        }

        if(action.payload?.redirectto) {
          if(action.payload?.redirectto === 'pdas') {
            yield put(push("/action-plans"))
          }

          if(action.payload?.redirectto === 'reports') {
            yield put(push("/reports/dashboard"))
          }

          break;
        }


        if (
          data.modules.length === 0 &&
          ROLES_ADMIN_MANDU.includes(data.active_role)
        ) {
          yield put(push("/companies"))
        } else {
          yield put(loginSuccess(data))
        }
        break
      case 422:
        var { error } = data
        if (isHash) {
          message.error("Error al ingresar a la plataforma de Engagement.")
        } else {
          if (has(error, "user")) {
            yield call(messageFailed, error.user[0])
          }

          if (has(error, "email") && !has(error, "password")) {
            yield call(messageFailed, error.email[0])
          }

          if (!has(error, "email") && has(error, "password")) {
            yield call(messageFailed, error.password[0])
          }

          if (has(error, "email") && has(error, "password")) {
            yield call(messageFailed, error.email[0])
            yield call(messageFailed, error.password[0])
          }
        }
        yield put(loginFailed())
        break
      case 429:
        var { error } = data
        if (has(error, "email")) {
          yield call(messageFailed, error.email[0])
        }
        yield put(loginFailed())
        break
      default:
        if (isHash) {
          message.error("Error al ingresar a la plataforma de Engagement.")
        } else {
          yield call(messageFailed, "Error en el servidor")
        }
        yield put(loginFailed())
        break
    }
  } catch (e) {
    yield call(messageFailed, "Error en el servidor")
    yield put(loginFailed())
  }
}

function resendCode(payload) {
  return axios.request({
    method: "post",
    url: `${process.env.API_URL}oauth/login/resend-two-factor-auth`,
    data: {...payload, loginLanguage: LOCAL_LOGIN_LANGUAGE()}
  })
}

export function* resendCodeSaga(action) {
  const { payload } = action
  try {
    yield call(resendCode, payload)
  } catch (e) {
    console.error(e)
  }
}

export default function* loginWatcherSaga() {
  yield takeLatest(LOGIN_WATCHER, loginSaga)
  yield takeLatest(LOGIN_COMPANY_WATCHER, loginCompanySaga)
  yield takeLatest(LOGIN_PROOF_INTEGRATED, loginProofIntegratedSaga)
  yield takeLatest(TWO_FACTOR_AUTH_RESEND_WATCHER, resendCodeSaga)
}
